import * as React from 'react';
import { FC } from 'react';
import * as Toggle from '@radix-ui/react-toggle';
import { Typography } from '../Typography';
import * as styles from './styles.css';
import { useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';

interface ITagsProps {
  onChange: (isPressed: boolean, value: string) => void;
  pressed?: boolean;
  disabled?: boolean;
  text: string;
  id: string;
  withBorder?: boolean;
}

export const Tag: FC<ITagsProps> = ({ onChange, pressed = false, disabled, text, id = '', withBorder = false }) => {
  const deviceType = useDeviceType();

  return (
    <Toggle.Root
      className={cn(styles['tag'], styles[deviceType], withBorder && styles['with-border'])}
      pressed={pressed}
      onPressedChange={isPressed => onChange(isPressed, id)}
      disabled={disabled}
    >
      <Typography.Text level={4} color="currentColor">
        {text}
      </Typography.Text>
    </Toggle.Root>
  );
};
